import { initialState } from '@/models/options';

/**
 * The invoices table gained a Project column and lost Compilation Code. Drop the
 * stale key and let the initial state supply the new one, while keeping whatever
 * the user had toggled for every other column.
 */
const v39 = (state: any) => {
  const { 'Compilation Code': _removed, ...kept } =
    state.options?.tableViews?.invoicesTable ?? {};

  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...initialState.tableViews.invoicesTable,
          ...kept,
        },
      },
    },
  };
};

export default v39;
